import { useUrlForPageId } from '../../../../../app/pages/ui/utils/useUrlForPageId';
import { ParkingPageId } from '../../../../domain/pages/ParkingPageId';

export function useFullAmendUrl(): string {
	return useUrlForPageId(ParkingPageId.FullAmendBookingAvailability);
}
